import { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { api, fmt, fmtDate, getUser } from '../api';
import { Loading, Eyebrow, rowNav } from '../ui';

export default function Dashboard() {
  const [d, setD] = useState<any>(null);
  const [err, setErr] = useState('');
  const user = getUser();
  const nav = useNavigate();

  const isKargo = user?.role === 'kargo';
  const load = () => { setErr(''); api.get('/dashboard').then(setD).catch((e) => setErr(e.message)); };
  useEffect(() => { if (!isKargo) load(); }, []);
  if (isKargo) return <Navigate to="/customs" replace />;
  if (err) return (
    <div className="empty">
      <div className="e-title">Ma'lumotni yuklab bo'lmadi</div>
      <div style={{ marginBottom: 14 }}>{err}</div>
      <button className="btn" onClick={load}>Qayta urinish</button>
    </div>
  );
  if (!d) return <Loading />;

  const t = d.transitTotals || { units: 0, boxes: 0, kg: 0, m3: 0 };
  const transit = d.transit || [];
  const aged = d.agedShortages || [];
  const receipts = d.recentReceipts || [];
  const today = new Date().toLocaleDateString('uz-UZ', { day: 'numeric', month: 'long', weekday: 'long' });
  const hour = new Date().getHours();
  const greet = hour < 6 ? 'Xayrli tun' : hour < 12 ? 'Xayrli tong' : hour < 18 ? 'Xayrli kun' : 'Xayrli kech';

  return (
    <div>
      <div className="hero">
        <div>
          <span className="h-date">● {today}</span>
          <h2>{greet},<br /><span className="h-name">{user?.fullName}</span></h2>
          <div className="h-sub">Bugun import jarayonini samarali boshqaring</div>
        </div>
        <div className="hero-stats">
          <div className="hero-stat"><div className="hs-v">{fmt(d.productsTotal)}</div><div className="hs-k">Nomenklatura</div></div>
          <div className="hero-stat"><div className="hs-v">{d.inTransitOrders}</div><div className="hs-k">Yo'lda</div></div>
          <div className="hero-stat"><div className="hs-v">{d.openShortages}</div><div className="hs-k">Yetmovchilik</div></div>
        </div>
      </div>

      <div className="stat-grid">
        <div className="stat accent">
          <div className="k">Yo'ldagi zakazlar</div>
          <div className="v">{d.inTransitOrders}</div>
          <div className="d">{fmt(t.kg, 1)} kg · {fmt(t.m3, 2)} m³ · {fmt(t.boxes)} mesta</div>
        </div>
        <div className={'stat' + (d.openShortages > 0 ? ' warn' : ' ok')}>
          <div className="k">Ochiq yetmovchilik</div>
          <div className="v">{d.openShortages}</div>
          <div className="d">{d.shortagesOver30 > 0 ? `${d.shortagesOver30} tasi 30+ kun` : 'muddati me’yorda'}</div>
        </div>
        <div className="stat">
          <div className="k">Katalog</div>
          <div className="v">{fmt(d.productsTotal)}</div>
          <div className="d">nomenklatura pozitsiyasi</div>
        </div>
        <div className={'stat' + (d.productsWithoutGroup > 0 ? ' danger' : ' ok')}>
          <div className="k">Guruhsiz mahsulot</div>
          <div className="v">{d.productsWithoutGroup}</div>
          <div className="d">{d.productsWithoutGroup > 0 ? 'rastamojka to‘xtab qoladi' : 'hammasi biriktirilgan'}</div>
        </div>
      </div>

      {(d.productsWithoutGroup > 0 || aged.length > 0) && (
        <>
          <Eyebrow title="Qaror kartalari" desc="e'tibor talab qiladigan holatlar — bosib o'ting" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            {d.productsWithoutGroup > 0 && (
              <Link to="/products?onlyNoGroup=true" className="alert-card danger">
                <div style={{ flex: 1 }}>
                  <div className="a-title">{d.productsWithoutGroup} ta mahsulotga rastamojka guruhi biriktirilmagan</div>
                  <div className="a-sub">bu mahsulotlar rastamojka hujjatida avtomatik guruhlanmaydi</div>
                </div>
                <span className="btn btn-sm">Ko'rish →</span>
              </Link>
            )}
            {aged.map((s: any) => (
              <div key={s.id} className={'alert-card' + (s.days > 30 ? ' danger' : '')}>
                <div style={{ flex: 1 }}>
                  <div className="a-title">{s.article} · {s.name} — {fmt(s.qtyMissing)} dona yetmayapti</div>
                  <div className="a-sub">{s.orderNumber} · {s.supplier || '—'} · {s.days} kun kutilmoqda</div>
                </div>
                <button className="btn btn-sm" onClick={() => nav('/shortages')}>Reyestr →</button>
              </div>
            ))}
          </div>
        </>
      )}

      <Eyebrow title="Yo'ldagi yuklar" desc="Xitoydan kelayotgan zakazlar — kg va kub bilan" />
      {transit.length === 0 ? (
        <div className="card"><p className="muted" style={{ margin: 0 }}>Hozircha yo'lda yuk yo'q. Zakaz jo'natilganda «Yo'lda» statusiga o'tkazing.</p></div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Zakaz</th><th>Zavod</th><th>Jo'natilgan</th><th className="num">Dona</th><th className="num">Mesta</th><th className="num">Kg</th><th className="num">m³</th></tr></thead>
            <tbody>
              {transit.map((o: any) => (
                <tr key={o.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/orders/' + o.id))}>
                  <td className="link">{o.number}</td>
                  <td>{o.supplier || '—'}</td>
                  <td>{fmtDate(o.shippedAt || o.orderDate)}</td>
                  <td className="num">{fmt(o.units)}</td>
                  <td className="num">{fmt(o.boxes, 1)}</td>
                  <td className="num">{fmt(o.kg, 1)}</td>
                  <td className="num">{fmt(o.m3, 2)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="total-row">
                <td colSpan={3}>JAMI YO'LDA</td>
                <td className="num">{fmt(t.units)}</td>
                <td className="num">{fmt(t.boxes, 1)}</td>
                <td className="num">{fmt(t.kg, 1)}</td>
                <td className="num">{fmt(t.m3, 2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}

      <Eyebrow title="So'nggi kirimlar" desc="oxirgi 5 ta qabul qilingan yuk" />
      {receipts.length === 0 ? (
        <div className="card"><p className="muted" style={{ margin: 0 }}>Hali kirim yo'q.</p></div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Raqam</th><th>Sana</th><th>Zakazlar</th><th className="num">Pozitsiyalar</th></tr></thead>
            <tbody>
              {receipts.map((r: any) => (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/receipts'))}>
                  <td className="link">{r.number}</td>
                  <td>{fmtDate(r.date)}</td>
                  <td>{r.orders.join(', ')}</td>
                  <td className="num">{r.positions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
